import { paths } from '@/routes/paths';
import { Button } from '@mui/material';
import { Error } from '../error';
import { Text } from '../error/styles';

export function FallBack() {
  return (
    <Error text="Um erro inesperado aconteceu!">
      <Text>Por favor, baixe os logs de depuração e envie ao suporte.</Text>

      <Button
        variant="contained"
        size="large"
        color="error"
        onClick={() => {
          window.electronAPI.downloadReport();
        }}
      >
        Baixar depuração
      </Button>

      <br />
      <br />
      <br />

      <Button color="inherit" onClick={() => window.location.reload()}>
        Recarregar (<kbd>F5</kbd>)
      </Button>

      <Button color="success" onClick={() => (window.location.href = paths.flow.desktop.signIn)}>
        Voltar para página inicial
      </Button>
    </Error>
  );
}
